import { createField } from '@src/shared/ui/fields';
import UserAutocompleteInput from './UserAutocompleteInput';

const AutocompleteField = createField(UserAutocompleteInput);

export default AutocompleteField;
